import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { Button, Modal } from "antd";
import PopupCard from "../../../../Auth/PopupCard";
import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../../../components/Elements/Tables/Tables";
import SortData from "../../../../../components/Elements/SortData.js/SortData";
import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
import { ReactComponent as CopyIcon } from "../../../../../assets/svgs/file-icon.svg";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import { useNavigate, useLocation } from "react-router-dom";
import { formatDate } from "../../../../../utils/UtilService";
import { Select } from "antd";
import UnlockProjectBeforeAssign from "../DailogBoxes/UnlockProjectBeforeAssign";
import { FaSitemap } from "react-icons/fa";
import ProjectSetup from "../DailogBoxes/ProjectSetup";
import useDebounce from "../../../../../hooks/debouncing";
const StandardSurveyForm = ({
  projectId,
  lockAction = true,
  setOpenAssignedForm,
  setAssignedFormtype,
  onSetupComplete,
  refreshTrigger = 0,
}) => {
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState(
    location.state?.standardFormSearch || "",
  );
  const [openSetupProject, setopenSetupProject] = useState(false);
  const [sortBy, setSortBy] = useState(null);
  const [projectData, setProjectData] = useState({});
  const [sortOrder, setSortOrder] = useState(null);
  const [currentPage, setCurrentPage] = useState(
    location.state?.standardFormPage || 1,
  );

  useEffect(() => {
    if (
      location.state?.standardFormPage !== currentPage ||
      location.state?.standardFormSearch !== searchTerm
    ) {
      navigate(".", {
        replace: true,
        state: {
          ...location.state,
          standardFormPage: currentPage,
          standardFormSearch: searchTerm,
        },
      });
    }
  }, [currentPage, searchTerm, navigate, location.state]);

  const [pageSize, setPageSize] = useState(10);
  const [unlockProjectPopup, setUnlockProjectPopup] = useState(false);
  const [unlockPopupConfig, setUnlockPopupConfig] = useState(null);
  const [hasMixedFrequencyForms, setHasMixedFrequencyForms] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showSetupRequiredPopup, setShowSetupRequiredPopup] = useState(false);
  const debouncedSearch = useDebounce(searchTerm, 500);
  const { Option } = Select;
  const user = useSelector((state) => state.auth?.user);

  const isFormLocked = useCallback((formRecord) => {
    if (!formRecord) return true;
    return !Boolean(formRecord.isFrequencyConfigured);
  }, []);

  const openFrequencySetupWarning = useCallback(() => {
    setUnlockPopupConfig({
      title: "Form Frequency Setup Required",
      message:
        "Before accessing or assigning this form, please complete the frequency setup from the Project Setup section.",
      bullets: [],
    });
    setUnlockProjectPopup(true);
  }, []);

  const skipValue = 0;
  const formatFrequency = useCallback((frequency) => {
    if (!frequency) return "-";

    const frequencyMap = {
      year: "Yearly",
      half_year: "Half Yearly",

      quaterly: "Quarterly",
      monthly: "Monthly",
    };

    const normalizedFrequency = String(frequency).toLowerCase();
    return frequencyMap[normalizedFrequency] || frequency;
  }, []);

  const surveyHeader = useMemo(() => [
    { label: "Sr. No.", key: "serial" },
    { label: "Form Name", key: "formName" },
    // { label: "Sections", key: "sectionCount" },

    { label: "Assigned On", key: "assignedOn" },
    {
      label: "Hierarchy",
      key: "hierarchy",
      style: { textAlign: "center" },
    },
    { label: "Authorized/Assigned", key: "Authorized" },

    { label: "Form Frequency", key: "frequency" },
    { label: "Action", key: "action" },
  ]);

  // Fetch data from API and store it
  const fetchTableData = useCallback(
    async (searchValue = "") => {
      try {
        const skipValue = (currentPage - 1) * pageSize;
        const response = await getApi({
          apiUrl: API_URLS.GET_STANDARDFORM(
            projectId,
            searchValue,
            currentPage,
            pageSize,
            skipValue,
          ),
        });

        const projectRes = await getApi({
          apiUrl: `/api/client/project/get/${projectId}`,
        });

        const projectForms = projectRes?.data?.standard_form || [];
        const modeMap = {};
        projectForms.forEach((f) => {
          if (f.id) {
            modeMap[f.id] = f.allotment_mode;
          }
        });

        console.log("API response -->", response);

        if (response?.success && response?.data && response.data.length > 0) {
          // setPageSize(response.limit);
          const hasConfigured = response.data.some(
            (form) => form?.isFrequencyConfigured === true,
          );
          const hasUnconfigured = response.data.some(
            (form) => form?.isFrequencyConfigured === false,
          );
          setHasMixedFrequencyForms(hasConfigured && hasUnconfigured);

          setTotalRecords(
            response.totalCount || response.total || response.data.length,
          );
          console.log("response.data -->", response.data);
          const data = response.data.map((item, index) => {
            const currentMode =
              modeMap[item._id] || item.allotment_mode || null;
            return {
              key: item._id,
              progress: item.progress,
              allotment_mode: currentMode,
              serial: (
                <div className="text-center" title="">
                  {(currentPage - 1) * pageSize + index + 1}
                </div>
              ),
              formName: (
                <div className="text-center" title="">
                  {item.title}
                </div>
              ),
              assignedOn: (
                <div className="text-center" title="">
                  {formatDate(item.AssignedOn)}
                </div>
              ),
              frequency: (
                <div className="text-center" title="">
                  {formatFrequency(item.frequency)}
                </div>
              ),

              Authorized: (
                <div className="text-center" title="">
                  {currentMode === "handle"
                    ? "Authorized"
                    : currentMode === "fill"
                      ? "Assigned"
                      : "-"}
                </div>
              ),

              hierarchy: (
                <div className="flex justify-center" title="">
                  <FaSitemap
                    className="text-[#005E45] hover:text-[#003d2f] cursor-pointer text-lg"
                    onClick={() =>
                      navigate(
                        `/organization/projects/standard-forms/hierarchy/${item._id}`,
                      )
                    }
                    title="View Hierarchy"
                  />
                </div>
              ),

              sectionCount: (
                <div className="text-center" title="">
                  {item.sectionCount || 0}
                </div>
              ),
              _id: item._id,
              // Store original values for mobile card display
              originalFormName: (
                <div className="text-center" title="">
                  {item.title}
                </div>
              ),
              originalAssignedOn: (
                <div className="text-center" title="">
                  {formatDate(item.AssignedOn)}
                </div>
              ),
              originalFrequency: formatFrequency(item.frequency),
              originalSections: item.sections || 0,
              // action: (
              //   <div className="flex gap-2 sm:gap-3">
              //     <Select
              //       placeholder="Action"
              //       style={{ width: 160 }}
              //       dropdownStyle={{ borderRadius: "8px" }}
              //       className="text-sm custom-green-select"
              //       onChange={(value) => {
              //         if (value === "assign") {
              //           if (lockAction) {
              //             setUnlockProjectPopup(true); // Show popup if locked
              //           } else {
              //             navigate(
              //               `/organization/projects/assign-form/${item._id}`,
              //               {
              //                 state: {
              //                   formName: item.title,
              //                 },
              //               },
              //             );
              //           }
              //         } else if (value === "authorize") {
              //           navigate(
              //             `/organization/projects/authorize-form/${item._id}`,
              //           );
              //         } else if (value === "view") {
              //           navigate(
              //             `/organization/projects/standard-forms/view/${item._id}`,
              //             {
              //               state: {
              //                 formTitle: item.title,
              //               },
              //             },
              //           );
              //         }
              //       }}
              //     >
              //       <Option value="assign">Assign Form to Fill</Option>
              //       {/* <Option value="authorize">Authorize Form to Manage</Option> */}
              //       <Option value="view">View Details</Option>
              //     </Select>

              //     <CopyIcon
              //       style={{ fontSize: "16px", cursor: "pointer" }}
              //       className="sm:text-lg"
              //     />
              //   </div>
              // ),
              // action: (
              //   <div className="justify-center   flex gap-2 sm:gap-3" title="">
              //     <Select
              //       placeholder="Action"
              //       style={{ width: 160 }}
              //       dropdownStyle={{ borderRadius: "8px" }}
              //       className="text-sm custom-green-select"
              //       value={null} // 👈 Always show placeholder

              //       onChange={(value) => {
              //         if (value === "assign") {
              //           if (lockAction) {
              //             setUnlockProjectPopup(true);
              //           } else {
              //             navigate(
              //               `/organization/projects/assign-form/${item._id}`,
              //               {
              //                 // state: { formName: item.title },
              //                 state: {
              //                   formName: item.title,
              //                   roleType: item.role_type, // <-- pass the role_type here
              //                   projectId: projectId,
              //                 },
              //               },
              //             );
              //           }
              //         } else if (value === "authorize") {
              //           navigate(
              //             `/organization/projects/authorize-form/${item._id}`,
              //           );
              //         } else if (value === "view") {
              //           navigate(
              //             `/organization/projects/standard-forms/view/${item._id}`,
              //             {
              //               state: {
              //                 formTitle: item.title,
              //                 projectId: projectId,
              //                 roleType: item.role_type,
              //               },
              //             },
              //           );
              //         }

              //         // 👇 Reset select back to placeholder after short delay
              //         setTimeout(() => {
              //           document.activeElement.blur(); // dropdown close karega
              //         }, 0);
              //       }}

              //     >
              //       <Option value="assign">Assign Form to Fill</Option>
              //       <Option value="authorize">Authorize Form to Manage</Option>
              //       <Option value="view">View Details</Option>
              //     </Select>

              //     {/* <CopyIcon
              //       style={{ fontSize: "16px", cursor: "pointer" }}
              //       className="sm:text-lg"
              //       title=""
              //     /> */}
              //   </div>
              // ),

              action: (
                <div
                  className="flex justify-center items-center gap-3"
                  title=""
                >
                  <EyeIcon
                    className="cursor-pointer text-[#2B3B49] transition-colors duration-150 hover:text-[#06513D]"
                    style={{ fontSize: "18px" }}
                    onClick={() => {
                      if (user && user.orgModeLocked === false) {
                        setShowSetupRequiredPopup(true);
                        return;
                      }
                      if (
                        hasMixedFrequencyForms &&
                        item.isFrequencyConfigured === false
                      ) {
                        openFrequencySetupWarning();
                        return;
                      }
                      if (isFormLocked(item)) {
                        setUnlockProjectPopup(true);
                        return;
                      }
                      navigate(
                        `/organization/projects/standard-forms/view/${item._id}`,
                        {
                          state: {
                            formTitle: item.title,
                            projectId: projectId,
                            roleType: item.role_type,
                            progress: item.progress,
                            source: "standard-form-list",
                            standardFormPage: currentPage,
                            standardFormSearch: searchTerm,
                            projectPageLocationState: location.state,
                          },
                        },
                      );
                    }}
                  />
                </div>
              ),
            };
          });

          setTableData(data);
        } else {
          // Handle case when no data found or success is false
          console.log("No data found or API returned success: false");
          setHasMixedFrequencyForms(false);
          setTableData([]);
        }
      } catch (error) {
        console.error("Error fetching standard survey forms:", error);
        // Handle error case - clear data
        setHasMixedFrequencyForms(false);
        setTableData([]);
      }
    },
    [
      projectId,
      lockAction,
      navigate,
      openFrequencySetupWarning,
      hasMixedFrequencyForms,
      setUnlockProjectPopup,
      currentPage,
      pageSize,
    ],
  );

  // Search functionality
  // const handleSearch = useCallback(
  //   (term) => {
  //     setSearchTerm(term); // Update search term state
  //     fetchTableData(term); // Fetch filtered data from API
  //   },
  //   [fetchTableData],
  // );
  const handleSearch = useCallback((term) => {
    setSearchTerm(term);
    setCurrentPage(1); // Search par page 1
  }, []);

  // Sorting functionality
  const handleSort = useCallback(
    (key, order) => {
      setSortBy(key);
      setSortOrder(order);
      setTableData((prevData) => SortData({ data: prevData, key, order }));
    },
    [setTableData],
  );

  // Memoized filtered data - keep for client-side filtering when needed
  const filteredData = useMemo(() => {
    // If search term exists, use tableData directly (already filtered by API)
    if (searchTerm) {
      return tableData;
    }

    // If no search term, return all tableData
    return tableData;
  }, [tableData, searchTerm]);

  // Handle card actions
  const handleCardAction = (value, itemId) => {
    if (user && user.orgModeLocked === false) {
      setShowSetupRequiredPopup(true);
      return;
    }

    const selectedForm = tableData.find((row) => row._id === itemId);

    if (value === "assign") {
      if (selectedForm?.allotment_mode === "handle") {
        Modal.error({
          title: "Authorization Conflict",
          content:
            "This form has already been authorized for management and delegation. Users with management authorization are responsible for assigning sections and monitoring progress.",
          okText: "Ok",
          centered: true,
        });
        return;
      }
      if (
        hasMixedFrequencyForms &&
        selectedForm?.isFrequencyConfigured === false
      ) {
        openFrequencySetupWarning();
        return;
      }
      if (isFormLocked(selectedForm)) {
        setUnlockProjectPopup(true);
      } else {
        navigate(`/organization/projects/assign-form/${itemId}`);
      }
    } else if (value === "authorize") {
      if (selectedForm?.allotment_mode === "fill") {
        Modal.error({
          title: "Assignment Conflict",
          content:
            "This form has already been assigned for data entry and cannot be authorized for management at the same time.",
          okText: "Ok",
          centered: true,
        });
        return;
      }
      navigate(`/organization/projects/authorize-form/${itemId}`);
    } else if (value === "view") {
      navigate(`/organization/projects/standard-forms/view/${itemId}`, {
        state: {
          formTitle: selectedForm?.title,
          projectId: projectId,
          roleType: selectedForm?.role_type,
          progress: selectedForm?.progress,
          source: "standard-form-list",
          standardFormPage: currentPage,
          standardFormSearch: searchTerm,
          projectPageLocationState: location.state,
        },
      });
    }
  };

  // Fetch data on mount or when `projectId`, pagination, or debounced search changes
  useEffect(() => {
    fetchTableData(debouncedSearch);
  }, [
    fetchTableData,
    lockAction,
    projectId,
    debouncedSearch,
    currentPage,
    pageSize,
  ]);

  // Parent (ProjectPage) increments refreshTrigger after project setup save.
  // This ensures standard forms are re-fetched even when pagination/search values are unchanged.
  useEffect(() => {
    fetchTableData(debouncedSearch);
  }, [refreshTrigger, fetchTableData, debouncedSearch]);

  // useEffect(() => {
  //   fetchTableData(searchTerm);
  // }, [currentPage, pageSize, searchTerm, projectId]);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleSetupComplete = useCallback(() => {
    fetchTableData(debouncedSearch);
    if (typeof onSetupComplete === "function") {
      onSetupComplete();
    }
  }, [fetchTableData, debouncedSearch, onSetupComplete]);
  // Card Component for Mobile View
  const SurveyCard = ({ item, index }) => (
    <div
      className="bg-white rounded-xl shadow-lg border border-gray-100 p-5 mb-4 transform transition-all duration-300 hover:shadow-xl hover:scale-[1.02] hover:border-[#3BA2B9] animate-slideInUp"
      style={{
        animationDelay: `${index * 0.1}s`,
        background: "linear-gradient(135deg, #ffffff 0%, #f8fffe 100%)",
        border: "1px solid #e0f2f1",
      }}
    >
      {/* Header with serial number */}
      <div className="flex justify-between items-center mb-4 pb-3 border-b border-gray-100">
        <span className="bg-gradient-to-r from-[#06513D] to-[#3BA2B9] text-white text-sm font-bold px-4 py-2 rounded-full">
          #{(currentPage - 1) * pageSize + index + 1}
        </span>
      </div>

      {/* Form Name */}
      <div className="flex justify-between items-start mb-4">
        <span className="text-sm font-semibold text-gray-600 min-w-[100px]">
          Form Name:
        </span>
        <span className="text-sm font-medium text-gray-800 text-right flex-1 ml-3">
          {item.originalFormName || "N/A"}
        </span>
      </div>

      {/* Sections */}
      <div className="flex justify-between items-center mb-4">
        <span className="text-sm font-semibold text-gray-600">Sections:</span>
        <span className="text-sm font-medium text-gray-800 bg-gray-100 px-3 py-1 rounded-full">
          {item.originalSections || "N/A"}
        </span>
      </div>

      {/* Frequency */}
      <div className="flex justify-between items-center mb-4">
        <span className="text-sm font-semibold text-gray-600">Frequency:</span>
        <span className="text-sm font-medium text-gray-800 bg-emerald-50 px-3 py-1 rounded-full ">
          {item.originalFrequency || "N/A"}
        </span>
      </div>

      {/* Assigned On */}
      <div className="flex justify-between items-center mb-4">
        <span className="text-sm font-semibold text-gray-600">
          Assigned On:
        </span>
        <span className="text-sm font-medium text-gray-800 bg-blue-50 px-3 py-1 rounded-full ">
          {item.originalAssignedOn || "N/A"}
        </span>
      </div>

      {/* Assigned/Authorized */}
      <div className="flex justify-between items-center mb-4">
        <span className="text-sm font-semibold text-gray-600">Authorized:</span>
        <span className="text-sm font-medium text-gray-800 bg-green-50 px-3 py-1 rounded-full ">
          {item.allotment_mode === "handle"
            ? "Authorized"
            : item.allotment_mode === "fill"
              ? "Assign"
              : "-"}
        </span>
      </div>

      {/* Action Section */}
      <div className="flex justify-between items-center pt-4 border-t border-gray-100">
        <span className="text-sm font-semibold text-gray-600">Action:</span>
        <div className="flex items-center gap-3">
          <Select
            placeholder="Choose Action"
            style={{ width: 140 }}
            dropdownStyle={{ borderRadius: "8px" }}
            className="text-sm custom-green-select"
            onChange={(value) => handleCardAction(value, item._id)}
          >
            <Option value="assign">Assign Form</Option>
            <Option value="authorize">Authorize Form</Option>
            <Option value="view">View Details</Option>
          </Select>

          {/* <button className="p-2 rounded-full bg-gray-100 hover:bg-[#06513D] hover:text-white transition-all duration-300 transform hover:scale-110">
            <CopyIcon style={{ fontSize: "16px" }} />
          </button> */}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* CSS Animations */}
      <style jsx>{`
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .animate-slideInUp {
          animation: slideInUp 0.6s ease-out forwards;
        }

        .animate-fadeIn {
          animation: fadeIn 0.8s ease-out;
        }

        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .custom-green-select .ant-select-selector {
          border-color: #3ba2b9 !important;
          border-radius: 8px !important;
        }

        .custom-green-select .ant-select-selector:hover {
          border-color: #06513d !important;
        }

        .custom-green-select.ant-select-focused .ant-select-selector {
          border-color: #06513d !important;
          box-shadow: 0 0 0 2px rgba(6, 81, 61, 0.1) !important;
        }
      `}</style>

      <div
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          backgroundColor: "white",
        }}
        className="w-full overflow-hidden animate-fadeIn"
      >
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row sm:justify-between mx-4 sm:mx-6 lg:mx-8 my-4 font-medium gap-4 sm:gap-0">
          {/* Left Section */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 lg:gap-16">
            <p className="text-[#06513D] pt-2 text-sm sm:text-base font-semibold">
              STANDARD SURVEY FORM
            </p>
            <div className="w-full sm:w-auto">
              <SearchBar
                width="100%"
                onSearch={handleSearch}
                className="min-w-[200px] sm:min-w-[250px] lg:min-w-[300px]"
              />
            </div>
          </div>
        </div>

        {/* Mobile Cards View (hidden on desktop) */}
        <div className="block md:hidden px-4 pb-4">
          {filteredData.length > 0 ? (
            <div className="space-y-4">
              {filteredData.map((item, index) => (
                <SurveyCard key={item.key} item={item} index={index} />
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <div className="text-gray-400 text-6xl mb-4">📋</div>
              <p className="text-gray-500 text-lg">No forms found</p>
              <p className="text-gray-400 text-sm">
                Try adjusting your search criteria
              </p>
            </div>
          )}
        </div>

        {/* Desktop Table View (hidden on mobile) */}
        <div className="hidden md:block overflow-x-auto">
          <Tables
            data={filteredData}
            headers={surveyHeader}
            pageSize={pageSize}
            current={currentPage}
            total={totalRecords}
            onChange={handlePageChange}
            sortBy={sortBy}
            sortOrder={sortOrder}
            onSort={handleSort}
            className="min-w-full"
          />
        </div>

        {unlockProjectPopup && (
          <UnlockProjectBeforeAssign
            onOpen={unlockProjectPopup}
            onClose={() => {
              setUnlockProjectPopup(false);
              setUnlockPopupConfig(null);
            }}
            // handleSave={() => setopenSetupProject(true)}
            handleSave={() => {
              setUnlockProjectPopup(false);
              setUnlockPopupConfig(null);
              setopenSetupProject(true);
            }}
            {...(unlockPopupConfig || {})}
          />
        )}

        {showSetupRequiredPopup && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] px-4">
            <PopupCard
              type="warning"
              title="Setup Required"
              message={`You cannot access forms because the required project setup has not been completed.\n\nPlease complete the following pending setup(s):\n• Organization Setup\n• Project Setup\n\nOnce the required setup is completed, all form-related actions will be available.`}
              confirmText="Go to Setup"
              cancelText="Cancel"
              onConfirm={() => {
                setShowSetupRequiredPopup(false);
                navigate("/organization/organization-setup");
              }}
              onCancel={() => setShowSetupRequiredPopup(false)}
              widthClass="w-full sm:w-[450px]"
            />
          </div>
        )}

        {openSetupProject && (
          <ProjectSetup
            onOpen={openSetupProject}
            projectId={projectId}
            statusFrequency={projectData.statusFrequency}
            onClose={() => setopenSetupProject(false)}
            onSetupComplete={handleSetupComplete}
          />
        )}
      </div>
    </>
  );
};

export default React.memo(StandardSurveyForm);
